import {useEffect} from "react";
import {useLocation} from "react-router";

export interface GoogleAnalyticsProps {
    measurementId: string
}

declare global {
    interface Window {
        gtag: any
    }
}

export function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {

    const location = useLocation();

    useEffect(() => {

        const url = location.pathname + location.search;

        if( typeof window !== 'undefined' && typeof window.gtag !== 'undefined' ) {

            window.gtag(
                'config',
                measurementId ,
                { page_path: url, page_search: location.search },
            );
        }

    }, [ measurementId, location.pathname, location.search ]);



    return (
        <>
        </>
    );

}